import { render, staticRenderFns } from "./scheduleConferenceSettings.vue?vue&type=template&id=64d0d64a&scoped=true&lang=pug&"
import script from "./scheduleConferenceSettings.vue?vue&type=script&lang=js&"
export * from "./scheduleConferenceSettings.vue?vue&type=script&lang=js&"
import style0 from "./scheduleConferenceSettings.vue?vue&type=style&index=0&id=64d0d64a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0d64a",
  null
  
)

export default component.exports